export enum CompanyRouteNameEnum {
	list = "companies.list",
	create = "companies.create",
}
